/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import {
  getUmasGenerales,
  postUmaGeneral,
  deleteUmaGeneral,
  patchUmaGeneral,
  getUmaGeneral,
} from 'api/catalogos/UmasGenerales';
import { checkToken } from 'api/utils';
import { getModelPermission } from 'utils/permission';
import { getEstadosGlobales } from 'api/catalogos';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import ModalConfirmation from 'components/ModalConfirmation';
import UmaValor, { umasValoresPermission } from './UmasValores';

export const umasGeneralesPermission = {
  permissionModel: 'umageneral',
  catalogsModels: [
    'periodofiscal',
  ],
  tabsModels: [],
};

const UmaGeneral = ({ permission }) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [estadosGlobales, setEstadosGlobales] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleCancelar, setvisibleCancelar] = useState(false);
  const [disableEditar, setDisableEditar] = useState(false);
  const [disableGrid, setDisableGrid] = useState(false);
  const [visibleInactivo, setVisibleInactivo] = useState(false);
  const [disableSave, setDisableSave] = useState(false);

  const getPermission = getModelPermission(
    umasValoresPermission.permissionModel,
    umasValoresPermission.catalogsModels,
    umasValoresPermission.tabsModels,
    false,
  );

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getUmasGenerales();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _periodos,
        _estadosGlobales,
        _data,
      ] = await Promise.all([
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getEstadosGlobales(),
        getUmasGenerales(),
      ]);
      if (mounted) {
        setPeriodos(_periodos);
        setEstadosGlobales(_estadosGlobales);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
    formDatos.resetFields();
    setDisableEditar(false);
    setDisableGrid(false);
    setVisibleInactivo(false);
    setDisableSave(false);
  };

  const isDisabled = (rowEstatus) => {
    if (rowEstatus !== ESTATUS_ACTIVO) setDisableSave(true);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _uma = await getUmaGeneral(match.id);
    setTimeout(() => {
      if (_uma) {
        setDisableEditar(true);
        _uma?.estados_globales !== ESTATUS_ACTIVO ? setDisableGrid(true) : setDisableGrid(false);
        form.resetFields();
        formDatos.resetFields();
        setTimeout(() => {
          isDisabled(_uma.estados_globales);
          form.setFieldsValue(formatReceived(_uma));
          formDatos.setFieldsValue(formatReceived(_uma));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const saved = await (key ? patchUmaGeneral(key, values) : postUmaGeneral(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteUmaGeneral(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una UMA ya autorizada');
      }
      const vals = {
        ...form.getFieldsValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchUmaGeneral(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setVisibleAutorizar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una UMA ya autorizada');
      }
      const vals = {
        ...form.getFieldsValue(),
        estados_globales: ESTATUS_CANCELADO,
      };
      const res = await patchUmaGeneral(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setvisibleCancelar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Año',
      dataIndex: 'periodo',
      key: 'periodo',
      width: 400,
      render: (val) => periodos.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 400,
      render: (val) => estadosGlobales.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    periodo: [requiredRule],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            disableDelete={
              data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
              || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
            }
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'umageneral', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
              {
                permission: { model: 'umageneral', action: 'cancelar' },
                onClick: () => setvisibleCancelar(true),
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                disabledBySelection: false,
                className: 'cancel',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO,
              },
            ]}
            permission={permission}
            mobileColIndex={0}
            allowExportPDF={false}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} UMA`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                allowSave={!disableSave}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="periodo"
                    label="Ejercicio"
                    rules={rules.periodo}
                    hasFeedback
                  >
                    <Select
                      dataSource={periodos}
                      disabled={disableEditar}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    initialValue={ESTATUS_ACTIVO}
                  >
                    <Select
                      dataSource={estadosGlobales}
                      disabled={!selectedRowKeys.length || disableGrid}
                      activeInactive={!disableGrid}
                      onChange={(val) => setVisibleInactivo(val === ESTATUS_INACTIVO)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {selectedRowKeys.length
                ? (
                  <>
                    <p style={{ fontWeight: 600, marginBottom: 0, color: '#D88F4F' }}>Valores UMA</p>
                    <UmaValor
                      permission={getPermission}
                      selected={selectedRowKeys[0]}
                      disableGrid={disableGrid}
                    />
                  </>
                ) : null}
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`UMA ${periodos.find((e) => e.id === form.getFieldValue('periodo'))?.descripcion}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setVisibleAutorizar(false);
          }}
          open={visibleAutorizar}
          contentTitle={`Autorizar UMA ${periodos.find((e) => e.id === form.getFieldValue('periodo'))?.descripcion}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          onFinishText="Continuar"
          onCancel={() => {
            setvisibleCancelar(false);
          }}
          open={visibleCancelar}
          title="Confirmación"
          contentTitle={`Cancelar UMA ${periodos.find((e) => e.id === form.getFieldValue('periodo'))?.descripcion}`}
          subContent="Esta acción no podrá revertirse"
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleInactivo(false);
          }}
          contentTitle={`Inactivar UMA ${periodos.find((e) => e.id === form.getFieldValue('periodo'))?.descripcion}`}
          open={visibleInactivo}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default UmaGeneral;
